const riot = require('riot');

riot.tag2('module-notifications', '<div class="s-full pb8"> <div class="pb16"> <div class="mb16 mb0-last" each="{item in sclazy.items}" data-is="item-notification" item="{item}"></div> </div> <div class="f fh s-full" if="{sclazy.isLoading}"> <div data-is="atom-loading"></div> </div> </div>', 'module-notifications,[data-is="module-notifications"]{display:block}', '', function(opts) {
    this.on('mount', () => {

      this.lastItem = null;
      let watch_limit = 128;

      this.sclazy = Sclazy({
        target: this.parent.refs.body,
        onload: async () => {
          let limit = 32;
          let items = [];

          this.sclazy.isLoading = true;
          this.update();

          items.push(...await this.fetchNotifications({limit, lastItem: this.lastItem}));

          this.sclazy.addItems(items);

          this.lastItem = items[items.length-1];

          let is_more = items.length === limit;
          this.sclazy.next(is_more);

          this.sclazy.isLoading = false;
          this.update();
        },

        onscrollend: () => {
          this.sclazy.load();
        }
      });

      this.update();
    });

    this.fetchNotifications = ({limit, lastItem}) => {
      let notifications_store = app.store.workspace_user.collection('notifications')
        .orderBy('created_at', 'desc')
        .limit(limit);

      if(lastItem) {
        notifications_store._ref = notifications_store._ref.startAfter(lastItem.doc);
      }

      return notifications_store.fetch({relation: true});
    };

    this.reload = () => {
      this.lastItem = null;
      this.sclazy.reset().load();
    };
});